module.exports = __webpack_public_path__ + "img/logo-lg.33fc2bf8.png";